import { useRouter } from 'next/router'
import React from 'react'
import styled from 'styled-components'
import ClientSignUp from 'components/ClientSignUp'
import { Box, Container } from 'components/Layout'
import Link from 'components/Link'
import Logo from 'components/Logo'
import { H4, Text } from 'components/Typography'
import { ROUTE } from 'constants/routes'
import { withGA4Provider } from 'hoc/withGoogleAnalytics'
import { withRedirect } from 'hoc/withRedirect'
import {
  GA4_PAGE_AREAS,
  GA4_SIGN_IN_AREAS,
} from 'providers/googleAnalytics/types'
import { COLOR, SPACE } from 'Theme'

const Wrapper = styled(Box)`
  background-color: ${COLOR.GRAYSCALE_6};
`

const SignUpPage = () => {
  const { query } = useRouter()

  const returnUrl = query?.returnUrl as string

  return (
    <Wrapper minHeight="100vh" pb={{ MOBILE: SPACE.PX_60 }}>
      <Container.Small
        pl={{ MOBILE: SPACE.PX_15, TABLET: 0 }}
        pr={{ MOBILE: SPACE.PX_15, TABLET: 0 }}
        flexDirection="column"
        alignItems="center"
      >
        <Box mt={{ MOBILE: 0, TABLET: SPACE.PX_20 }} mb={SPACE.PX_20}>
          <Link href={ROUTE.FRONT_PAGE()} aria-label="home">
            <Logo />
          </Link>
        </Box>
        <H4 mb={SPACE.PX_30}>Sign up</H4>

        <ClientSignUp />
        <Text color={COLOR.GRAYSCALE_2} mt={SPACE.PX_15}>
          Already have client account?{' '}
          <Link
            href={ROUTE.SIGN_IN({
              fromUrl: GA4_SIGN_IN_AREAS.SIGN_UP_CLIENT,
              ...(returnUrl && { returnUrl }),
            })}
          >
            Sign in.
          </Link>
        </Text>
      </Container.Small>
    </Wrapper>
  )
}

SignUpPage.seoProps = {
  description:
    "Create new account to enjoy video consultations with the world's top Experts.",
}

const SignUp = withGA4Provider({
  page_area: GA4_PAGE_AREAS.SIGN_UP_CLIENT,
})(SignUpPage)

export default withRedirect({
  isWithReturnUrl: true,
  redirectRouteForAll: false,
})(SignUp)
